(function($){
    $(".sideNav__submenu.scroll > li > a").click(function(event) {
        event.preventDefault();
        var headerHeight = $(".header").outerHeight();
        var mainSubpageHeadHeight = $(".main__subpageHead").outerHeight();
        var anchor = $(this).attr('href');

        $(window).scrollTo($("" + anchor + ""), 1000, {
            interrupt: true,
            offset: {
                left: 0,
                top: -(headerHeight + 15)
            }
        });
    });

    $(".scroll").on("click", function(event) {
        event.preventDefault();
        var anchor = $(this).attr('href');
        var headerHeight = $("main").outerHeight();
        var headerHeight = 0;

        $(window).scrollTo($("" + anchor + ""), 1000, {
            interrupt: true,
            offset: {
                left: 0,
                top: -(headerHeight + 250)
            }
        });
    });
}(jQuery));